<!--  -->
import { clearInterval } from 'timers';
import { setInterval } from 'timers';
<template>
    <div class='left1_container box_v'>
        <div class="title1">各业务办理件数</div>
        <div class="box title_right">
            <div class="title2">总办件数</div>
            <div class="title3">{{total}}</div>
            <div class="title2">件</div>
        </div>
        <div v-for="(item,index) in list" :key="index" class="box_f1 box" style="align-items:center">
            <div class="item box">
                <div class="title box">{{item.estateTypeName}}</div>
                <div class="box_f1">
                    <div class="line" :style="{width:item.width}"></div>
                </div>
                <div class="number box">{{item.handleCount}}{{handelTag}}</div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    props:['communityId'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            total:0,
            list:[],
            handelData:[],
            handelTag:'',
            timer:null,
            totalNum:0,
            communityIds:1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        communityId:{
            handler(newVal){
                if(this.communityIds != newVal){
                    this.communityIds = newVal;
                    this.getData(this.communityIds)
                }
            },
            deep:true
        }
    },
    //方法集合
    methods: {
        getData(communityId){
            this.$get(this.urlobj.getHandleCount,{
                communityId:communityId
            })
            .then(res=>{
                let maxNum = res.rows[0].handleCount
                this.list = res.rows.splice(0,7).map(item=>{
                    return {
                        estateTypeName:item.estateTypeName,
                        handleCount:maxNum>10000?(item.handleCount/10000).toFixed(2):item.handleCount,
                        width:(item.handleCount/maxNum).toFixed(2)*100 + '%'
                    }
                })
                this.handelTag = maxNum>10000?'万件':'件'

                this.total=res.newPrimaryKeys.handleTotalCount.toLocaleString()
                this.getMockTotal(res.newPrimaryKeys.handleTotalCount-50)
            })
        },
        getMockTotal(total){
            if(this.timer){
                clearInterval(this.timer)
                this.timer = null
            }
            this.total = (total-50).toLocaleString()
            this.totalNum = total-50
            
            this.timer = setInterval(()=>{
                this.totalNum = this.totalNum + 1
                this.total =  this.totalNum.toLocaleString()
            },2000)
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData(this.communityIds)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    }, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.left1_container{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/estate/left1.png');
    background-size: 100% 100%;
    height:100%;
}

.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:30px 0 0 50px
}
.title_right{
    justify-content: flex-end;
    margin-right:20px;
    margin-top:-20px;
}
.title2{
    font-size: 14px;
    color: #FF9941;
    margin-top:14px;
}
.title3{
    margin-left:10px;    
    font-size: 30px;
    font-style: italic;
    color: #B3DDFF;
    font-weight: bold;
    background: linear-gradient(0deg, #F5A418 0%, #EA7A24 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-right:4px;
    marin-top:-4px
}

.item{
    height:40px;
    line-height: 40px;
    color: #B3DDFF;
    box-shadow:0 0 3px #008cff inset; 
    margin: 0px 20px 0 20px;
    padding: 0 10px;
    width:100%;
    .title{
        width:120px;
        margin-right:10px
    }
    .line{
        height: 10px;
        background: linear-gradient(90deg,#029EFE 0%, rgba(1, 125, 255, 0.2) 100%);
        border-radius: 5px;
        margin-top: 15px;
    }
    .number{
        width:70px;
        font-size: 18px;
        font-style: italic;
        color: #B3DDFF;
        line-height: 40px;
        background: linear-gradient(0deg, #00A8FF 0%, #4CECFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-left: 10px;
        text-align: right;
    }
}
</style>